"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XcreoHandler = void 0;
const types_1 = require("./types");
var DigitOneWidget;
(function (DigitOneWidget) {
    DigitOneWidget["DEFAULT"] = "4";
})(DigitOneWidget || (DigitOneWidget = {}));
var DigitTwoNotUsed;
(function (DigitTwoNotUsed) {
    DigitTwoNotUsed["DEFAULT"] = "0";
})(DigitTwoNotUsed || (DigitTwoNotUsed = {}));
var DigitThreeOptimizedReason;
(function (DigitThreeOptimizedReason) {
    DigitThreeOptimizedReason["NOT_OPTIMIZED"] = "0";
    DigitThreeOptimizedReason["GEO"] = "1";
    DigitThreeOptimizedReason["OOS"] = "2";
})(DigitThreeOptimizedReason || (DigitThreeOptimizedReason = {}));
var DigitFourLinkType;
(function (DigitFourLinkType) {
    DigitFourLinkType["ORIGINAL_NAKED"] = "0";
    DigitFourLinkType["ORIGINAL_UPDATED_OR_REPLACED"] = "1";
    DigitFourLinkType["ALTERNATIVE"] = "2";
})(DigitFourLinkType || (DigitFourLinkType = {}));
var DigitFiveDynamicOptions;
(function (DigitFiveDynamicOptions) {
    DigitFiveDynamicOptions["OPTIMIZED_EXISTING_BUTTON_AND_ALTERNATIVE_BUTTONS_OPTION"] = "0";
    DigitFiveDynamicOptions["OPTIMIZING_EXISTING_BUTTON_OPTION_ONLY"] = "1";
    DigitFiveDynamicOptions["ALTERNATIVE_BUTTONS_OPTION_ONLY"] = "2";
})(DigitFiveDynamicOptions || (DigitFiveDynamicOptions = {}));
var DigitSixABTesting;
(function (DigitSixABTesting) {
    DigitSixABTesting["DEFAULT"] = "0";
})(DigitSixABTesting || (DigitSixABTesting = {}));
//const XCREO_PREFIX = "400";
const XCREO_ORIGINAL_ATTR = "data-skim-creative";
const XCREO_PARAM_NAME = "xcreo";
/**
 * DynamicButtonsClickUrlParameter sets the url GET (search) parameter for the DynamicButtons
 *
 * @class XcreoHandler
 */
class XcreoHandler {
    #digitFive;
    #htmlElementAttributeHandler;
    constructor(htmlElementAttributeHandler) {
        this.#digitFive = DigitFiveDynamicOptions.OPTIMIZED_EXISTING_BUTTON_AND_ALTERNATIVE_BUTTONS_OPTION;
        this.#htmlElementAttributeHandler = htmlElementAttributeHandler;
    }
    setupOptimizationReason(replaceOrUpdateOriginal, maxLinksPerCard) {
        if (replaceOrUpdateOriginal) {
            this.#digitFive =
                maxLinksPerCard > 1
                    ? DigitFiveDynamicOptions.OPTIMIZED_EXISTING_BUTTON_AND_ALTERNATIVE_BUTTONS_OPTION
                    : DigitFiveDynamicOptions.OPTIMIZING_EXISTING_BUTTON_OPTION_ONLY;
        }
        else {
            this.#digitFive = DigitFiveDynamicOptions.ALTERNATIVE_BUTTONS_OPTION_ONLY;
        }
    }
    // /**
    //  * @throws {Error} if the url is not a valid URL
    //  * @param url
    //  * @param buttonMode
    //  */
    // public appendXcreoParameterFromString(url: string, buttonMode: ButtonMode): string {
    //   const uri = new URL(url);
    //   this.appendXcreoParameter(uri, buttonMode);
    //   return uri.toString();
    // }
    /**
     * Creates a new URL with the xcreo parameter, respecting existing xcreo query parameter
     * @param url {URL} - the URL to append the xcreo parameter to
     * @param buttonMode {ButtonAction} - the actual mode of the button
     */
    appendURLWithXcreo(url, buttonMode) {
        let value = this.#getXcreoUrl(buttonMode);
        if (!url.searchParams.has(XCREO_PARAM_NAME)) {
            url.searchParams.set(XCREO_PARAM_NAME, value);
        }
    }
    #getXcreoUrl(buttonMode) {
        let value = "";
        switch (buttonMode) {
            case types_1.ButtonMode.ALTERNATIVE:
                value = this.#generateXcreoUrl(DigitFourLinkType.ALTERNATIVE);
                break;
            case types_1.ButtonMode.REPLACE:
            case types_1.ButtonMode.UPDATE:
                value = this.#generateXcreoUrl(DigitFourLinkType.ORIGINAL_UPDATED_OR_REPLACED);
                break;
            case types_1.ButtonMode.DEFAULT:
                value = this.#generateXcreoUrl(DigitFourLinkType.ORIGINAL_NAKED);
                break;
            default:
                throw new Error(`Invalid button mode: ${buttonMode}`);
        }
        return value;
    }
    #generateXcreoUrl(digitFour) {
        return `${DigitOneWidget.DEFAULT}${DigitTwoNotUsed.DEFAULT}${DigitThreeOptimizedReason.NOT_OPTIMIZED}${digitFour}${this.#digitFive}${DigitSixABTesting.DEFAULT}`;
    }
    removeXcreoFromHtmlElement(el) {
        this.#htmlElementAttributeHandler.removeAttribute(el, XCREO_ORIGINAL_ATTR);
    }
    addXcreoToHtmlElement(el, buttonMode) {
        this.#htmlElementAttributeHandler.setAttribute(el, XCREO_ORIGINAL_ATTR, this.#getXcreoUrl(buttonMode));
    }
}
exports.XcreoHandler = XcreoHandler;
